export default __webpack_public_path__ + "static/media/ke.a75d4943.jpg";